import Button from '@atlaskit/button';
import {
  G500,
  G50,
  N0,
  N40,
  B50,
  B200,
  B400,
  B500
} from '@atlaskit/theme/colors';
import styled from 'styled-components';

export const EctlRecord = styled.div`
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  position: relative;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;

export const Product = styled.div`
  width: auto;
`;

export const ProductName = styled.p`
  margin-top: 0;
  margin-bottom: 0;
`;

export const ProductDescription = styled.span`
  font-weight: normal;
`;

export const CurrentLicense = styled.div`
  width: auto;
  white-space: nowrap;
`;

export const CurrentLicenseDescription = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
`;

export const EctlDescription = styled.div`
  width: auto;
  white-space: nowrap;
`;

export const EctlExpiration = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: ${G500};
  font-size: 0.85em;
  font-weight: 600;
  background-color: ${G50};
  padding: 3px 5px;
  white-space: nowrap;
  display: inline-block;
`;

export const CtaButton = styled(Button)`
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  font-weight: 500;
  color: ${N0} !important;
  :enabled,
  :enabled:hover {
    background-color: ${B400};
    color: ${N0} !important;
  }
  :enabled:hover {
    background-color: ${B500};
  }
  :disabled,
  :disabled:hover {
    background-color: ${N40};
  }
`;

export const ectlListCss = `
.ectl-record-ctrl {
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 10px;
  box-sizing: border-box;
  border: 0.5px solid transparent;
  min-width: 750px;
}
.ectl-record-ctrl:hover, .ectl-record-ctrl-selected {
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 10px;
  border-radius: 5px;
  border: 0.5px solid transparent;
  background-color: ${B50};
  cursor: pointer;
  min-width: 750px;
}
.ectl-record-ctrl:hover .ectl-cta, .ectl-record-ctrl-selected .ectl-cta {
  display:inline-block;
}
.ectl-record-ctrl-selected {
  border: 0.5px solid ${B200};
  border-radius: 5px;
  cursor: default;
}
.ectl-record-ctrl-claimed, .ectl-record-ctrl-claimed:hover {
  cursor: default;
  margin-bottom:12px;
}
.ectl-record {
  display: inline-block;
}
.radio-button {
  vertical-align: top;
  display: inline-block;
  padding-top: 2px;
  align-self: flex-start;
  margin-right: 8px;
}
.ectl-record-ctrl-selected .radio-button input[type=radio] {
  margin-right: 8px;
}

.ectl-record-ctrl .radio-button input[type=radio] {
  margin-right: 8px;
  cursor: pointer;
}
.ectl-cta {
  margin-left: auto;
  display: none;
  height: 100%;
}
`;
